/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCellSignal3 = createReactComponent("cell-signal-3", "IconCellSignal3", [
  [
    "path",
    {
      d: "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M12 20v-9", key: "svg-1" }]
]);

export { IconCellSignal3 as default };
//# sourceMappingURL=IconCellSignal3.js.map
